import { isEmpty, set } from 'lodash'
import { AsyncValidateCallback } from 'redux-form'
import { isDate } from 'date-fns'
import { fireToastError } from '../../../../actions/toasts/fireToast'
import i18n from '../../../../i18n'
import { getPrice } from '../../../../models/Price/mappers/mapValuesToRequestPriceForm'
import { IDateRange } from '../../../../utils/Date'

export interface ISetPriceFormErrors {
  dates?: IDateRange[]
  rooms?: string
}

export default function() {
  return function(values, dispatch, props): Promise<ISetPriceFormErrors> {
    return new Promise((resolve, reject) => {
      const { dates, selectedRooms } = values
      const errors: ISetPriceFormErrors = {}
      dates.forEach((date, i) => {
        if (!isDate(date.from)) {
          set(errors, `dates[${i}].from`, i18n.t('reservation_no_date_error'))
        }

        if (!isDate(date.to)) {
          set(errors, `dates[${i}].to`, i18n.t('reservation_no_date_error'))
        }
      })
      if (isEmpty(selectedRooms)) {
        set(errors, 'rooms', i18n.t('BBO_963_select_room'))
      }
      const fields = props.registeredFields
      const matchedFields = Object.keys(fields).filter(
        k =>
          k.includes('price') ||
          k.includes('additional') ||
          k.includes('kid') ||
          k.includes('adult'),
      )
      const filteredFields = matchedFields.filter(k => {
        const cat = getPrice(values, k)
        return cat === null || cat === undefined
      })

      if (filteredFields.length !== matchedFields.length) {
        filteredFields.forEach(k => set(errors, k, true))
      }
      if (isEmpty(errors)) {
        resolve({})
      } else {
        if (!isEmpty(errors.dates)) {
          dispatch(
            fireToastError(
              i18n.t('reservation_no_date_error'),
              null,
              'Main',
              'setPriceEmptyDate',
            ),
          )
        }
        if (!isEmpty(errors.rooms)) {
          dispatch(
            fireToastError(errors.rooms, 5000, 'Main', 'setPriceEmptyRoom'),
          )
        }
        reject(errors)
      }
    })
  }
}

export function shouldAsyncValidate(
  params: AsyncValidateCallback<any, string>,
): boolean {
  return params.trigger === 'submit' && params.trigger !== undefined
}
